// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mSJh","right":"styles_right__1N-jm"};